<!--
 * @Author:
 * @LastEditTime: 2022-04-18 17:11:49
 * @Description: 操作角色权限
-->
<template>
  <div>
    <el-dialog
      class="mini-dialog"
      v-dialogDrag
      :append-to-body="true"
      :visible.sync="permissionProps.visible"
      :title="permissionProps.title"
    >
      <el-form label-width="100px">
        <el-form-item label="选择权限">
          <el-card class="wraper--tree overflow-y-auto m-t-10">
            <el-tree
              v-loading="treeLoading"
              v-if="permissionProps.visible"
              :data="permissionTreeData"
              show-checkbox
              node-key="name"
              ref="tree"
              :props="defaultProps"
            >
            </el-tree>
          </el-card>
        </el-form-item>
      </el-form>
      <div slot="footer" class="flex justify-center">
        <el-button size="small" type="primary" class="iconfont icon-save" @click="save()"
          >保存</el-button
        >
        <el-button size="small" class="iconfont icon-close" @click="cancel()">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// import PermissionService from '@/services/oidcLoginService/Permissions'
import { PermissionsApi } from '@wiz-api/abp-permission-management'

const permissionsApi = new PermissionsApi()

export default {
  props: {
    permissionProps: {
      type: Object,
      default: () => {
        return {
          visible: true,
          providerKey: '',
          providerName: '',
          title: '',
        }
      },
    },
  },
  name: 'operateRolePerssionDialog',
  components: {},
  data() {
    return {
      treeLoading: false,
      permissionTreeData: [],
      defaultProps: {
        label: 'displayName',
        children: 'permissions',
      },
      defaultCheckedNodes: [],
    }
  },
  watch: {
    permissionProps: {
      deep: true,
      immediate: true,
      handler(props) {
        if (props.visible) {
          this.getPermissions()
        }
      },
    },
  },
  methods: {
    cancel() {
      this.permissionProps.visible = false
    },
    async save() {
      let checkedNodes = _.filter(this.$refs.tree.getCheckedNodes(), (item) => {
        return _.has(item, 'isGranted')
      })
      checkedNodes = _.map(checkedNodes, (item) => {
        return {
          isGranted: true,
          name: item.name,
        }
      })
      // 默认节点的isGranted置为false(设置过true的，想取消授权还得设置为false)
      let permissionDefalultCheckedNodes = _.filter(this.defaultCheckedNodes, (item) => {
        return !_.find(checkedNodes, ['name', item.name])
      })
      permissionDefalultCheckedNodes = _.map(permissionDefalultCheckedNodes, (item) => {
        return {
          isGranted: false,
          name: item.name,
        }
      })
      // const res = await PermissionService.updatePermission({
      //   query: {
      //     providerKey: this.permissionProps.providerKey,
      //     providerName: this.permissionProps.providerName,
      //   },
      //   payload: {
      //     permissions: [...permissionDefalultCheckedNodes, ...checkedNodes],
      //   },
      // })
      const [err, res] = await permissionsApi.update({
        providerKey: this.permissionProps.providerKey,
        providerName: this.permissionProps.providerName,
        body: {
          permissions: [...permissionDefalultCheckedNodes, ...checkedNodes],
        },
      })
      if (!err) {
        this.$message.success('修改权限成功')
        this.permissionProps.visible = false
      }
    },
    // 获取用户所有权限
    async getPermissions() {
      this.treeLoading = true
      this.defaultCheckedNodes = []
      // const res = await PermissionService.getPermissions({
      //   providerName: this.permissionProps.providerName,
      //   providerKey: this.permissionProps.providerKey,
      // })
      const [err, res] = await permissionsApi.get({
        providerName: this.permissionProps.providerName,
        providerKey: this.permissionProps.providerKey,
      })
      if (!err) {
        this.permissionTreeData = res.groups
        _.forEach(this.permissionTreeData, (item) => {
          const permissions = _.cloneDeep(item.permissions)
          // 用户继承角色的权限禁用
          if (this.permissionProps.providerName === 'U') {
            let rootItemDisabled = true
            _.forEach(item.permissions, (permissionItem) => {
              permissionItem.disabled =
                permissionItem.isGranted && permissionItem.grantedProviders[0].providerName === 'R'
              if (!permissionItem.disabled) {
                rootItemDisabled = false
              }
            })
            item.disabled = rootItemDisabled
          }
          // 获取默认选中节点
          this.defaultCheckedNodes = [
            ...this.defaultCheckedNodes,
            ..._.filter(permissions, 'isGranted'),
          ]
          // 过滤没有parentName的
          item.permissions = _.filter(item.permissions, (permissionItem) => {
            return _.isNil(permissionItem.parentName)
          })
          // 通过parentName找到并添加到模块permissions下
          _.forEach(item.permissions, (cItem) => {
            cItem.permissions = _.filter(permissions, (permissionCItem) => {
              // 用户继承角色的权限禁用
              if (this.permissionProps.providerName === 'U') {
                permissionCItem.disabled =
                  permissionCItem.isGranted &&
                  permissionCItem.grantedProviders[0].providerName === 'R'
              }
              return permissionCItem.parentName === cItem.name
            })
          })
        })
        // 默认选中节点
        this.$nextTick(() => {
          this.$refs.tree.setCheckedNodes(this.defaultCheckedNodes)
          this.treeLoading = false
        })
      }
    },
  },
  created() {},
}
</script>
<style lang="scss" scoped>
.wraper--tree {
  height: 500px;
}
</style>
